import React, { FC } from 'react';
import { ReactComponent as UserWaitingSvg } from 'assets/svgs/user-waiting.svg';
import { ClassNameOnlyProps } from 'components/ozone-component';

const UserWaiting: (size: number) => FC<ClassNameOnlyProps> =
  (size) =>
  ({ className }) =>
    <UserWaitingSvg className={className} width={size} height={size} />;

export const UserWaiting16 = UserWaiting(16);
export const UserWaiting20 = UserWaiting(20);
export const UserWaiting24 = UserWaiting(24);
export const UserWaiting32 = UserWaiting(32);
